import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import Breadcrumb from './Breadcrumb';
import BrowseAllProducts from './BrowseAllProducts';

export const LocationBar = () => {
	const {
		breadcrumb,
		showAllProductsDetailText,
		showAllProductsDetailLink,
	} = useSelector((state) => state);

	const { DesignSystemV3Enabled } = useSelector(
		(state) => state.featureSwitches
	);

	if (breadcrumb) {
		return (
			<div
				className="py-4 px-4 bg-white"
				data-tag-section="lister location bar">
				<div
					className={classNames('mx-auto', {
						'max-w-screen-2xl': DesignSystemV3Enabled,
						'max-w-screen-xl': !DesignSystemV3Enabled,
					})}>
					<div className="flex text-body-xs font-bold">
						<div className="flex-grow pr-2">
							<Breadcrumb breadcrumb={breadcrumb} />
						</div>
						<div className="flex-shrink pl-2">
							<BrowseAllProducts
								text={showAllProductsDetailText}
								link={showAllProductsDetailLink}
								category={breadcrumb[0]?.Title}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return null;
};

export default LocationBar;
